import { render, staticRenderFns } from "./InvestorRelations.vue?vue&type=template&id=080f7898&scoped=true&"
import script from "./InvestorRelations.vue?vue&type=script&lang=js&"
export * from "./InvestorRelations.vue?vue&type=script&lang=js&"
import style0 from "./InvestorRelations.vue?vue&type=style&index=0&id=080f7898&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080f7898",
  null
  
)

export default component.exports